/**
 * ImageLightbox — Fullscreen image overlay with zoom and close on click/escape.
 */

import { useEffect, useCallback } from "react";
import styles from "./ImageLightbox.module.css";

interface ImageLightboxProps {
  src: string;
  alt?: string;
  onClose: () => void;
}

export function ImageLightbox({ src, alt, onClose }: ImageLightboxProps) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [handleKeyDown]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <button className={styles.closeBtn} onClick={onClose} aria-label="Schließen">
        ✕
      </button>
      <img
        src={src}
        alt={alt ?? "Bild"}
        className={styles.image}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
